import React from "react";
import ComingSoon from "../../components/ComingSoon/ComingSoon";
import GoToTop from "../../helpers/GoToTop";

function PromoSoon() {
  return (
    <>
      <GoToTop />
      <ComingSoon type={"promo"} />
    </>
  );
}

export default PromoSoon;
